import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Schedule, tpTheme } from "@trainingpeaks/designtokens";
import { Subscription } from "@appTypes/index";
import useEnablePremiumAutoRenewalBanner from "@hooks/useEnablePremiumAutoRenewalBanner";

interface EnablePremiumAutoRenewalBannerProps {
  subscription: Subscription;
}

const EnablePremiumAutoRenewalBanner = ({ subscription }: EnablePremiumAutoRenewalBannerProps) => {
  const { t } = useTranslation();
  const { handleRenew, isRenewing, renewError } = useEnablePremiumAutoRenewalBanner(subscription);

  return (
    <Box
      className="flex flex-col gap-1 px-4 py-3 rounded-lg mb-4 bg-primary-background"
      data-testid="premium-auto-renewal-banner"
    >
      <Box className="flex items-center justify-between gap-4">
        <Box className="flex items-center gap-3">
          <Schedule size="24" fill={tpTheme.semanticLayer.colors.primary.main} />
          <Typography variant="body2">
            {t("Keep your goals in sight -- renew Premium to stay on track for race day.")}
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className="rounded-full shrink-0"
          onClick={() => handleRenew()}
          disabled={isRenewing}
        >
          {isRenewing ? <CircularProgress size={16} color="inherit" /> : t("Renew")}
        </Button>
      </Box>
      {renewError && (
        <Typography variant="body2" color="error">
          {t(renewError)}
        </Typography>
      )}
    </Box>
  );
};

export default EnablePremiumAutoRenewalBanner;

